export enum SearchStatus {
  SUCCESS,
  ERROR,
  LOADING,
  MISSING_INFO,
}
